
import React from 'react';
import { Grid, Row, Col } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import { FooterContainer, Inline, Hover, TextSpace, WappenLogo } from './FooterStyle'

const Footer = () => {

  const thisYear = new Date().getFullYear()

  return (
    <FooterContainer>
      <Grid fluid>
        <Row>
          <Col lg={9} md={8} xs={12}>
            <Inline>
              <TextSpace />
              <WappenLogo />
              <TextSpace />
              <Col smHidden xsHidden>
                <p style={{letterSpacing: 0}}>The exclusive business & lifestyle network</p>
              </Col>
              <TextSpace />
              <p style={{letterSpacing: 0}}>&copy; {thisYear} All rights reserved.</p>
          </Inline>
          </Col>
          <Col lg={3} md={4} xs={12} xsHidden smHidden>
            <Inline style={{float: 'right'}}>
              <LinkContainer to='/impressum'><Hover> Impressum</Hover></LinkContainer>
              <LinkContainer to='/datenschutz'><Hover> Datenschutz</Hover></LinkContainer>
              <LinkContainer to='/kontakt'><Hover> Kontakt</Hover></LinkContainer>
            </Inline>
          </Col>
        </Row>
      </Grid>
    </FooterContainer>
  );
};

export default Footer;



// WEBPACK FOOTER //
// /src/components/layout/Footer.js